import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Observable, Subscription } from 'rxjs';

@Component({
    selector: 'app-add-action',
    templateUrl: './add-action.component.html',
    styleUrls: ['./add-action.component.scss'],
    standalone: false
})
export class AddActionComponent implements OnInit {

  @Output() addAction: EventEmitter<any> = new EventEmitter();
  @Input() actionObject
  @Input() added : boolean = false
  @Input() withTitle: boolean = false
  @Input() events: Observable<any>;
  @Input() isReminder: boolean

  
  private eventsSubscription: Subscription;
  
  constructor() { 
  }

  onToggle(){
    this.added = !this.added
    this.addAction.emit({ added: this.added, action: this.actionObject })
  }

  doSomething(action){

    if( this.actionObject.title == action.title ){
      this.added = action.added
    }
  }

  ngOnInit() {

    this.eventsSubscription = this.events.subscribe((action) => this.doSomething(action));

  }

  ngOnDestroy() {
    this.eventsSubscription.unsubscribe();
  }

}
